import { useState } from "react"
import Button from "../../../../../common/Button"
// import CustomSelectAsync from "../../../../../common/interactive/CustomSelectAsync"
import { assignCaseLiability, assignCaseMedPayUM, caseQuickUpdate } from "../../../../../../lib/fetchApi"
import { useDispatch, useSelector } from "react-redux"
import { caseActions } from "../../../../../../store/case"
import { notificationActions } from "../../../../../../store/notifications"
import { policeReportFunctions } from "../../../../../../lib/policeReport"
import CustomSelectAsyncSingle from "../../../../../common/interactive/CustomSelectAsyncSingle"

export default function TransferInsurance({classes, item, folder, allFields}) {
    const dispatch = useDispatch()
    const [showSearchField, setShowSearchField] = useState(false)
    const [searchInsurance, setSearchInsurance] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    if (policeReportFunctions.isMoonbirdReportProcessed(activeCase)) {
        return null
    }

    const atFaultmatch = {
        'false': 1,
        'true': 2,
    }

    const asignHandler = async (folder, insurance) => {
        let modFields = allFields.filter(field => !field.should_not_copy_over).map(field => {
            return {
                field: field.insurance_field,
                value: field.at_fault_custom_check ? atFaultmatch[policeReportFunctions.getReportField(item, field.value)] : policeReportFunctions.getReportField(item, field.value),
            }
        })

        let objectFields = modFields.reduce((acc, curr) => {
            acc[curr.field] = curr.value;
            return acc;
        }, {});

        if (insurance) {
            setIsLoading(true)

            try {
            // need to change api based on tab since Liabilities, Medpay, Um uses the same insurance api 

            if (folder == 'liabilities') {
                let reqBody = {
                    insurance_carrier_id: insurance,//required
                    location_id: null,
                    adjuster_id: null 
                }
                const asignedItem = await assignCaseLiability(userToken, activeCase.case.id, reqBody)
    
                if (asignedItem?.id) {
                    dispatch(caseActions.insertLiabilityInActiveCase(asignedItem))
                    setShowSearchField(false)
                    setSearchInsurance(null)

                    let reqBody = {
                        type: 'case_liability',
                        type_id: asignedItem.id,
                        fields: objectFields
                        // fields: {
                        //     policy_number: item.policy_number,
                        //     insured_name: item.name_on_policy,
                        // }
                    }
                    const updatedItem = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch, true)
       
                    if (updatedItem && updatedItem.errorMessage) {
                        dispatch(notificationActions.setError(updatedItem))
                    } else {
                        let dispatchBody = {
                            folder: 'liabilities',
                            item: {
                                itemId: asignedItem.id,
                                fields: modFields
                                // fields: [
                                //     {
                                //         field: 'policy_number',
                                //         value: item.policy_number,
                                //     },
                                //     {
                                //         field: 'insured_name',
                                //         value: item.name_on_policy,
                                //     }
                                // ]
                            }
                        }
                        dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
                    }
                } else {
                    dispatch(notificationActions.setError(asignedItem))
                }
            } 

            if (folder == 'mp_pip_um') {
                const asignedItem = await assignCaseMedPayUM(userToken, activeCase.case.id, {
                    insurance_carrier_id: insurance,//required
                    location_id: null,
                    adjuster_id: null 
                })

                if (asignedItem?.id) {
                    // dispatch(attorneyActions.setAssignedAttorney(attorney))
                    dispatch(caseActions.insertMedPayUMInActiveCase(asignedItem))    
                    setShowSearchField(false)
                    setSearchInsurance(null)

                    let reqBody = {
                        type: 'case_mp_pip_um',
                        type_id: asignedItem.id,
                        fields: objectFields
                        // fields: {
                        //     policy_number: item.policy_number,
                        //     insured_name: item.name_on_policy,
                        // }
                    }
                    const updatedItem = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch, true)
       
                    if (updatedItem && updatedItem.errorMessage) {
                        dispatch(notificationActions.setError(updatedItem))
                    } else {
                        let dispatchBody = {
                            folder: 'mp_pip_um',
                            item: {
                                itemId: asignedItem.id,
                                fields: modFields
                                // fields: [
                                //     {
                                //         field: 'policy_number',
                                //         value: item.policy_number,
                                //     },
                                //     {
                                //         field: 'insured_name',
                                //         value: item.name_on_policy,
                                //     }
                                // ]
                            }
                        }
                        dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
                    }
                } else {
                    dispatch(notificationActions.setError(asignedItem))
                }
            } 

            } finally {
                setIsLoading(false)
            }
        } 
    }


    function transferInsuranceFromSearchHandler(value) {
        asignHandler(folder, searchInsurance.data.value)
    }

    function transferInsuranceHandler() {

        if (item.insurance_carrier_id) {
            asignHandler(folder, {id: item.insurance_carrier_id})
        } else {
            setShowSearchField(true)
        }
    }

    function searchInsuranceHandler(value) {
        setSearchInsurance(value)
    }
    

    return <div className={classes.group_row}>
        <div className={classes.label}>
            
        </div>
        <div className={classes.value}>
            {showSearchField ? <>
                <h4 className={classes.search_title}>Direct transfer insurance is not possible, please search for the insurance and transfer it</h4>
                <div className="flex-container">
                    <CustomSelectAsyncSingle label={'Insurances Search'} path={'insurance-carriers'} action={searchInsuranceHandler} />
                    <Button click={transferInsuranceFromSearchHandler} btnStyle={'btn_simple'} isLoading={isLoading} loaderType={'dark'}><i className="ti ti-transfer"></i> Transfer</Button>
                </div>

            </> : 
            <Button click={transferInsuranceHandler} btnStyle={'btn_simple'} isLoading={isLoading} loaderType={'dark'}><i className="ti ti-transfer"></i> Transfer Insurance</Button>}
            
        </div>
        <div className={classes.status}>            
            
        </div>
        <div className={classes.value}>                
            
        </div>
    </div>
}